/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { CloneTabResponse } from '../model/cloneTabResponse';
// @ts-ignore
import { Tab } from '../model/tab';
// @ts-ignore
import { TabCloneRequest } from '../model/tabCloneRequest';
// @ts-ignore
import { TabMoveRequest } from '../model/tabMoveRequest';
// @ts-ignore
import { TabOrdersResponse } from '../model/tabOrdersResponse';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { WorkspacesAPIConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';
import {
    TabControllerServiceInterface,
    AddTabRequestParams,
    CloneTabRequestParams,
    DeleteTabRequestParams,
    MoveTabRequestParams,
    UpdateTabRequestParams
} from './tabController.serviceInterface';

@Injectable({
    providedIn: 'root'
})
export class TabControllerService extends BaseService implements TabControllerServiceInterface {
    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration?: WorkspacesAPIConfiguration
    ) {
        super(basePath, configuration);
    }

    /**
     * Add tab to workspace
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addTab(
        requestParameters: AddTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Tab>;
    public addTab(
        requestParameters: AddTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Tab>>;
    public addTab(
        requestParameters: AddTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Tab>>;
    public addTab(
        requestParameters: AddTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling addTab.');
        }
        const tab = requestParameters?.tab;
        if (tab === null || tab === undefined) {
            throw new Error('Required parameter tab was null or undefined when calling addTab.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Tab>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: tab,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Clone tab
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cloneTab(
        requestParameters: CloneTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<CloneTabResponse>;
    public cloneTab(
        requestParameters: CloneTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<CloneTabResponse>>;
    public cloneTab(
        requestParameters: CloneTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<CloneTabResponse>>;
    public cloneTab(
        requestParameters: CloneTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling cloneTab.');
        }
        const tabId = requestParameters?.tabId;
        if (tabId === null || tabId === undefined) {
            throw new Error('Required parameter tabId was null or undefined when calling cloneTab.');
        }
        const tabCloneRequest = requestParameters?.tabCloneRequest;

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs/${this.configuration.encodeParam({ name: 'tabId', value: tabId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/clone`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<CloneTabResponse>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: tabCloneRequest,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Delete tab
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteTab(
        requestParameters: DeleteTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any>;
    public deleteTab(
        requestParameters: DeleteTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<any>>;
    public deleteTab(
        requestParameters: DeleteTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<any>>;
    public deleteTab(
        requestParameters: DeleteTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteTab.');
        }
        const tabId = requestParameters?.tabId;
        if (tabId === null || tabId === undefined) {
            throw new Error('Required parameter tabId was null or undefined when calling deleteTab.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs/${this.configuration.encodeParam({ name: 'tabId', value: tabId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Move tab to new position with automatic reordering
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveTab(
        requestParameters: MoveTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<TabOrdersResponse>;
    public moveTab(
        requestParameters: MoveTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<TabOrdersResponse>>;
    public moveTab(
        requestParameters: MoveTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<TabOrdersResponse>>;
    public moveTab(
        requestParameters: MoveTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling moveTab.');
        }
        const tabMoveRequest = requestParameters?.tabMoveRequest;
        if (tabMoveRequest === null || tabMoveRequest === undefined) {
            throw new Error('Required parameter tabMoveRequest was null or undefined when calling moveTab.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs/move`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<TabOrdersResponse>('put', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: tabMoveRequest,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Update tab
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTab(
        requestParameters: UpdateTabRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Tab>;
    public updateTab(
        requestParameters: UpdateTabRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Tab>>;
    public updateTab(
        requestParameters: UpdateTabRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Tab>>;
    public updateTab(
        requestParameters: UpdateTabRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateTab.');
        }
        const tabId = requestParameters?.tabId;
        if (tabId === null || tabId === undefined) {
            throw new Error('Required parameter tabId was null or undefined when calling updateTab.');
        }
        const tab = requestParameters?.tab;
        if (tab === null || tab === undefined) {
            throw new Error('Required parameter tab was null or undefined when calling updateTab.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/workspaces/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/tabs/${this.configuration.encodeParam({ name: 'tabId', value: tabId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Tab>('put', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: tab,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }
}
